import React from "react";

const CompanyCard = ({ ticker, name, logo, color = "20,98,125" }) => (
  <div className="Company">
    <img className="Company-img" src={logo} alt={name} />
    <div className="Company-data">
      <div className="Title Title--l" style={{ color: `rgba(${color}, 1)` }}>
        {ticker}
      </div>
      <div className="Text u-spacer" style={{ color: `rgba(${color}, 1)` }}>
        {name}
      </div>
    </div>
  </div>
);

export default CompanyCard;
